import React, { memo } from "react";
import AddBoxIcon from "@mui/icons-material/AddBox";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  TextField,
  IconButton,
  Grid,
  Autocomplete,
  Tooltip,
  Typography,
  Box,
} from "@mui/material";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import AddIcon from "@mui/icons-material/Add";

//FUNCTION
function AddCardSales({
  itemList,
  handleAutocompleteChange,
  handleInputChange,
  handleAddItem,
  handleDeleteItem,
  items,
  errors,
  with_gst,
}) {
  const highlightMatch = (text, query) => {
    const safeText = typeof text === "string" ? text : "";
    const safeQuery = typeof query === "string" ? query : "";

    const words = safeQuery.toLowerCase().split(" ").filter(Boolean);
    if (!words.length) return safeText;

    const escaped = words.map((w) =>
      w.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")
    );
    const regex = new RegExp(`(${escaped.join("|")})`, "gi");

    return safeText.split(regex).map((part, index) => {
      if (part == null || part === "") {
        return <React.Fragment key={index} />;
      }
      const partLower = String(part).toLowerCase();
      return words.includes(partLower) ? (
        <mark key={index} style={{ backgroundColor: "#ffe58f" }}>
          {part}
        </mark>
      ) : (
        <React.Fragment key={index}>{part}</React.Fragment>
      );
    });
  };

  return (
    <>
      <div>
        <motion.div
          style={{
            width: "100%",
            backgroundColor: "#eeeef0",
            padding: 0,
            borderRadius: "10px",
            border: "none",
            margin: "10px",
            display: "flex",
            justifyContent: "center",
          }}
          initial={{ opacity: 0, y: 15 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.1, delay: 0.1 }}
        >
          <div>
            <Grid container>
              <Link to="/master-entry/item">
                <Tooltip title={"Add item"}>
                  <AddIcon
                    sx={{
                      cursor: "pointer",
                      color: "white",
                      backgroundColor: "grey",
                      margin: "5px",
                    }}
                    justifyContent="flex-end"
                  />
                </Tooltip>
              </Link>
            </Grid>
            {itemList.map((item, index) => (
              <div key={item.id}>
                <Grid
                  container
                  alignItems={"center"}
                  spacing={{ xs: 1, md: 1, lg: 1 }}
                  key={item.id}
                  sx={{ my: 1 }}
                >
                  <Grid item xs={12} sm={6} md={4} columnSpacing={0}>
                    <Autocomplete
                      disablePortal
                      freeSolo={false} // ❌ Strictly restricts custom user input text
                      id="combo-box-item"
                      size="small"
                      autoSelect={false} // ⚠️ False rakho, nahi toh random incomplete typing par bhi pehla option select ho jayega
                      clearOnBlur={true} // ✅ True rakho, agar dropdown se select nahi kiya toh blur hote hi text gayab ho jayega
                      selectOnFocus
                      handleHomeEndKeys
                      sx={{ backgroundColor: "white" }}
                      value={items.find((it) => it.item_code === item.item_code) || null}
                      options={items}
                      getOptionLabel={(option) =>
                        option
                          ? `${option.item_name || ""}(${option.item_code || ""})${option.unit ? `-${option.unit}` : ""
                          }`
                          : ""
                      }
                      isOptionEqualToValue={(option, value) =>
                        option.item_code === value.item_code
                      }
                      filterOptions={(options, { inputValue }) => {
                        const words = (inputValue || "")
                          .toLowerCase()
                          .split(" ")
                          .filter(Boolean);
                        return options.filter((option) => {
                          const name = option.item_name?.toLowerCase() || "";
                          const code = option.item_code?.toLowerCase() || "";
                          const unit = option.unit?.toLowerCase() || "";
                          return words.every(
                            (word) =>
                              name.includes(word) ||
                              code.includes(word) ||
                              unit.includes(word)
                          );
                        });
                      }}
                      onChange={(event, newValue) => {
                        // ✅ Agar valid option dropdown se select hua hai toh change karo, nahi toh blank ("") pass karo
                        if (newValue) {
                          handleAutocompleteChange(newValue.item_name, item.id);
                        } else {
                          handleAutocompleteChange("", item.id); // Blank string block
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          label="Item Name"
                          name="itemname"
                          // ❌ Yaha se manual onChange aur onKeyDown hata diya hai taaki uncontrolled random typing data state me na jaye
                          error={errors[`${index}`]?.itemname ? true : false}
                          sx={{ backgroundColor: "white" }}
                        />
                      )}
                      renderOption={(props, option, { inputValue }) => {
                        const label = `${option?.item_name || ""}(${option?.item_code || ""
                          })${option?.unit ? `-${option.unit}` : ""}`;
                        return (
                          <li {...props}>
                            <Box
                              sx={{
                                whiteSpace: "normal",
                                wordWrap: "break-word",
                                maxWidth: "100%",
                              }}
                            >
                              <Typography variant="body2">
                                {highlightMatch(label, inputValue)}
                              </Typography>
                            </Box>
                          </li>
                        );
                      }}
                    />
                  </Grid>

                  {/* <Grid item xs={12} sm={6} md={1.5}>
                    <TextField
                      sx={{ backgroundColor: "white" }}
                      size="small"
                      label="Unit"
                      variant="outlined"
                      type="text"
                      fullWidth
                      name="unit"
                      value={item.unit}
                      InputProps={{ readOnly: true }}
                      InputLabelProps={{
                        shrink: item.unit ? true : false,
                      }}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={6} md={1.5}>
                    <TextField
                      sx={{ backgroundColor: "white" }}
                      size="small"
                      label={item.unit ? item.unit : "Qty"}
                      variant="outlined"
                      type="number"
                      fullWidth
                      name="qty"
                      value={item.qty}
                      InputLabelProps={{
                        shrink: item.qty ? true : false,
                      }}
                      onChange={(e) => handleInputChange(e, item.id)}
                      error={
                        errors[`${index}`] !== undefined
                          ? !!errors[`${index}`].qty
                          : false
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      sx={{ backgroundColor: "white" }}
                      size="small"
                      label="Rate(₹)"
                      variant="outlined"
                      type="number"
                      fullWidth
                      name="rate"
                      value={item.rate || ""}
                      onChange={(e) => handleInputChange(e, item.id)}
                    />
                  </Grid>
                  {Boolean(with_gst) === true && (
                    <Grid item xs={12} sm={6} md={1}>
                      <TextField
                        sx={{ backgroundColor: "white" }}
                        size="small"
                        label="Tax(%)"
                        variant="outlined"
                        type="number"
                        fullWidth
                        name="Taxrate"
                        value={item.Taxrate || ""}
                        onChange={(e) => handleInputChange(e, item.id)}
                      />
                    </Grid>
                  )}
                  <Grid item xs={12} sm={6} md={1.5}>
                    <TextField
                      sx={{ backgroundColor: "white" }}
                      size="small"
                      label="Amount(₹)"
                      variant="outlined"
                      type="number"
                      fullWidth
                      name="amount"
                      value={item.amount}
                      InputLabelProps={{ shrink: item.amount ? true : false }}
                      InputProps={{ readOnly: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={1.5}>
                    <Tooltip title={"Add item"}>
                      <IconButton onClick={() => handleAddItem(item.id)}>
                        <AddBoxIcon fontSize="medium" sx={{ color: "green" }} />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title={"Delete item"}>
                      <IconButton
                        hidden={itemList.length > 1 ? false : true}
                        onClick={() => handleDeleteItem(item)}
                      >
                        <DeleteIcon
                          fontSize="medium"
                          sx={{ color: "#d43529" }}
                        />
                      </IconButton>
                    </Tooltip>
                  </Grid>

                  {/* 
                    <Grid item xs={12} sm={6} md={2} columnSpacing={0}>
                      <TextField 
                          sx={{backgroundColor:'white'}} 
                          size="small" 
                          label="Item Code" 
                          variant="outlined" 
                          type="text"
                          fullWidth 
                          name="item_code" 
                          value={item.item_code}  
                          InputLabelProps={{ shrink: item.item_code?true:false }}
                          InputProps={{ readOnly: true }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6} md={2} >
                      <TextField 
                        sx={{backgroundColor:'white'}} 
                        size="small" 
                        label="HSN" 
                        variant="outlined" 
                        type="text"
                        fullWidth 
                        name="hsn_code" value={item.hsn_code} 
                        InputLabelProps={{ shrink: item.hsn_code?true:false }}
                        InputProps={{ readOnly: true }}
                      />
                    </Grid> 
                  */}
                </Grid>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </>
  );
}

export default memo(AddCardSales);
